import React from 'react'
import {
    Button,
    Table, Container, Row, Col, Label,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import SimpleDropdown from '../view/DropDownView'
import DateTextField from '../view/DateTextField'
import { getBacklog, getBacklogReport } from '../model/request/backlog'
import { updateBacklogs } from '../model/request/backlog'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { addUserTimeZoneJson } from '../model/DateConverter'
import {JustDate} from '../model/JustDate';
import {
    InfoButton,
} from '../view/InfoButton'
import dateFormat from 'dateformat'

class BacklogReportViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            jobs: [],
            objectbacklogs: [],
            backlogs: [],
            backlog: 'Materials Ordered (Expected Date)',
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()
        getBacklog().then(
            (result) => {
                this.setState({
                    'objectbacklogs': result.data.backlogs,
                    'backlogs': result.data.backlogs
                        .map((b, i) => b.label),
                })

                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        this.search()
    }

    search(backlog) {
        backlog = backlog || this.state.backlog
        this.props.turnOnLoader()
        getBacklogReport(backlog).then(
            (result) => {
                this.setState({
                    'jobs': addUserTimeZoneJson(result.data.jobs),
                })

                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    indexOfBacklog(backlog) {
        return this.state.backlogs.indexOf(backlog || this.state.backlog)
    }

    nextLabel() {
        const label = this.state.backlogs[this.indexOfBacklog()+1]

        if (this.state.backlog === 'Materials Ordered (Expected Date)') {
            return label + ' / Ready For Production Date'
        }

        return label + ' Date'
    }

    // MARK: Render

    renderRows() {
        return this.state.jobs.map((job, index) =>
            <tr key={"row"+index}>
                <td><Label>
                    <a href={'/backlog/' + job.id} text={job.job_name}>{job.job_name}</a>
                </Label></td>
                <td><Label>
                    <a href={'/customerreport?filter=All&company=' + job.customer_name}>
                        {job.customer_name}
                    </a>
                </Label></td>
                <td><Label><span text={moneyText(job.total_price)}>{formatAsDollarValue(job.total_price)}</span></Label></td>
                <td><Label>{job.materials}</Label></td>
                <td><Label><span text={dateOffsetText(job.date_given)}>{dateFormat(job.date_given.toDateTime(), 'mmmm d, yyyy')}</span></Label></td>
                <td>
                    <input type="checkbox" checked={job.is_checked}
                        style={{
                            'display': 'inline-block',
                        }}
                        onChange={(e) => {
                            const jobs = this.state.jobs
                            jobs[index].is_checked = !jobs[index].is_checked

                            if (jobs[index].is_checked && jobs[index].date_picked === undefined) {
                                jobs[index].date_picked = new JustDate()
                            }

                            this.setState({
                                'jobs': jobs,
                            })
                        }} />
                    <div style={{
                        'display': 'inline-block',
                        'width': 'min(600px, 100% - 22px)',
                        'marginLeft': '8px',
                    }}>
                        <DateTextField
                            style={{
                                'display': 'inline-block',
                            }}
                            value={job.date_picked}
                            showModal={this.props.showModal}
                            closeModal={this.props.closeModal}
                            onChange={(d) => {
                                const jobs = this.state.jobs
                                jobs[index].date_picked = d
                                this.setState({
                                    'jobs': jobs,
                                })
                            }}
                            />
                    </div>
                </td>
                <td><Button
                    color={'success'}
                    onClick={(e) => {
                        this.props.turnOnLoader()

                        const backlogsToUpdate = job.backlogs_recieved || []

                        if (job.is_checked) {
                            backlogsToUpdate.push({
                                is_checked: job.is_checked,
                                quote_id: job.id,
                                type_id: this.state.objectbacklogs[this.indexOfBacklog() + 1]
                                    .id,
                                date_given: job.date_picked,
                            })

                            if (this.state.backlog === 'Materials Ordered (Expected Date)') {
                                backlogsToUpdate.push({
                                    is_checked: job.is_checked,
                                    quote_id: job.id,
                                    type_id: '3d936366-25cf-4077-8abe-340c5c1882c5',
                                    date_given: job.date_picked,
                                })
                            }
                        }


                        updateBacklogs(backlogsToUpdate).then(
                            (result) => {
                                job.backlogs_recieved = result.data.backlogs.map((backlog, index) => {
                                    backlog.is_checked = false
                                    return backlog
                                })
                                this.props.turnOffLoader()
                            },
                            (error) => {
                                this.props.showError(error)
                                this.props.turnOffLoader()
                            }
                        )
                    }}>Save</Button></td>
            </tr>
        )
    }

    render() {
        return (
            <Container>
                <Row><Col>
                    <InfoButton
                        id={'backlogreport'}
                        message={
                            'All Jobs that have their latest stage is specified below. ' +
                            'Does not include shipped Jobs.'
                        } />
                </Col></Row>
                <Row><Col>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '450',
                    }}>Backlog</Label><br />
                    <SimpleDropdown
                        index={this.indexOfBacklog()}
                        values={this.state.backlogs}
                        onChange={(index) => {
                            this.search(this.state.backlogs[index])
                            this.setState({
                                'backlog': this.state.backlogs[index],
                            })
                        }} />
                </Col></Row>
                <Row>
                    <Col>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '450',
                        'marginRight': '8px',
                    }}>Total Price:</Label>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '400',
                    }}>{(() => {
                        const total = this.state.jobs.length > 0 ?
                            this.state.jobs.map((x) => x.total_price)
                                .reduce((l, r) => l+r) : 0
                        return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                    })()}</Label>
                    </Col>
                </Row>
                <Row><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Job</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Customer</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Total Cost</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Materials</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>{this.state.backlog} Date</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}
                                >{this.nextLabel()}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRows()}
                    </tbody>
                </Table></div></Col></Row>
            </Container>
        )
    }
}

export default BacklogReportViewController

